"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingSocketEvents = exports.TrackingActionMessages = exports.TrackingActionCategory = exports.TrackingUserActionTypes = void 0;
var lodash_pick_1 = __importDefault(require("lodash.pick"));
var TrackingUserActionTypes;
(function (TrackingUserActionTypes) {
    TrackingUserActionTypes["TOGGLE"] = "Toggle";
    TrackingUserActionTypes["TYPING"] = "Typing";
    TrackingUserActionTypes["CLICK"] = "Click";
    TrackingUserActionTypes["CHECKBOX"] = "Checkbox";
    TrackingUserActionTypes["SELECT"] = "Select";
    TrackingUserActionTypes["FOCUS"] = "Focus";
})(TrackingUserActionTypes = exports.TrackingUserActionTypes || (exports.TrackingUserActionTypes = {}));
var TrackingActionCategory;
(function (TrackingActionCategory) {
    TrackingActionCategory["EVENT"] = "Event";
    TrackingActionCategory["INSTALLATION"] = "Installation";
    TrackingActionCategory["REBUILD"] = "Rebuild";
    TrackingActionCategory["DEVICE"] = "Device";
    TrackingActionCategory["INTERFACE"] = "Interface";
    TrackingActionCategory["TEMPLATE"] = "Template";
    TrackingActionCategory["ALERT"] = "Alert";
    TrackingActionCategory["PLANNING"] = "Planning";
    TrackingActionCategory["USER"] = "User";
    TrackingActionCategory["INVITATION"] = "Invitation";
    TrackingActionCategory["ORGANIZATION"] = "Organization";
    TrackingActionCategory["COUNTING"] = "Counting";
    TrackingActionCategory["AIR_QUALITY"] = "AirQuality";
    TrackingActionCategory["REPORT"] = "Report";
    TrackingActionCategory["STOP_N_GO"] = "StopNGo";
    TrackingActionCategory["ANALYTICS"] = "Analytics";
    TrackingActionCategory["API"] = "Api";
    TrackingActionCategory["ACTIVITY"] = "Activity";
    TrackingActionCategory["SERVER"] = "SERVER";
    TrackingActionCategory["RETAIL"] = "RETAIL";
})(TrackingActionCategory = exports.TrackingActionCategory || (exports.TrackingActionCategory = {}));
var defaultOptions = {
    create: "Create",
    edit: "Edit",
    stop: "Stop",
    delete: "Delete",
    cancel: "Cancel",
};
var defaultWorkerOptions = {
    create: "Create",
    start: "Start",
    finished: "Finished",
    mailSent: "Mail sent",
};
var defaultUIOptions = {
    sort: "Sort",
    search: "Search",
    filter: "Filter",
    export: "Export",
    refresh: "Refresh",
    open: "Open",
    changeTheme: "Change theme",
    modalClose: "Modal close",
};
exports.TrackingActionMessages = (_a = {},
    _a[TrackingActionCategory.EVENT] = __assign(__assign(__assign({}, defaultOptions), defaultUIOptions), { showStatus: "Show status", hideStatus: "Hude status", createPeriod: "Create period" }),
    _a[TrackingActionCategory.INSTALLATION] = __assign(__assign({}, defaultOptions), defaultUIOptions),
    _a[TrackingActionCategory.REBUILD] = __assign(__assign({}, defaultWorkerOptions), defaultUIOptions),
    _a[TrackingActionCategory.DEVICE] = __assign(__assign(__assign(__assign({}, defaultUIOptions), { link: "Link" }), (0, lodash_pick_1.default)(defaultOptions, ["edit"])), (0, lodash_pick_1.default)(defaultUIOptions, ["search", "sort"])),
    _a[TrackingActionCategory.INTERFACE] = __assign(__assign({}, defaultOptions), defaultUIOptions),
    _a[TrackingActionCategory.TEMPLATE] = __assign(__assign({}, defaultOptions), defaultUIOptions),
    _a[TrackingActionCategory.ALERT] = __assign(__assign(__assign({}, defaultOptions), defaultWorkerOptions), { smsSent: "Sms sent", pushSent: "Push sent", createCondition: "Create condition", deleteCondition: "Delete condition", editCondition: "Edit condition", createAction: "Create action", deleteAction: "Delete action", editAction: "Edit action" }),
    _a[TrackingActionCategory.PLANNING] = __assign(__assign(__assign(__assign({}, defaultOptions), defaultWorkerOptions), defaultUIOptions), { smsSent: "Sms sent" }),
    _a[TrackingActionCategory.USER] = __assign(__assign(__assign({}, defaultOptions), defaultUIOptions), { addAccess: "Add access", deleteAccess: "Delete access", autoRevokeAccess: "Auto revoke access" }),
    _a[TrackingActionCategory.INVITATION] = __assign(__assign(__assign(__assign({}, defaultUIOptions), (0, lodash_pick_1.default)(defaultOptions, ["create"])), (0, lodash_pick_1.default)(defaultWorkerOptions, ["mailSent"])), { resend: "Resend", revoke: "Revoke", accept: "Accept" }),
    _a[TrackingActionCategory.ORGANIZATION] = __assign(__assign({}, defaultOptions), defaultUIOptions),
    _a[TrackingActionCategory.COUNTING] = __assign(__assign({}, (0, lodash_pick_1.default)(defaultUIOptions, ["export"])), defaultUIOptions),
    _a[TrackingActionCategory.AIR_QUALITY] = __assign(__assign({}, (0, lodash_pick_1.default)(defaultUIOptions, ["export"])), defaultUIOptions),
    _a[TrackingActionCategory.REPORT] = __assign(__assign(__assign({}, defaultOptions), defaultWorkerOptions), defaultUIOptions),
    _a[TrackingActionCategory.STOP_N_GO] = __assign(__assign(__assign({}, defaultUIOptions), (0, lodash_pick_1.default)(defaultOptions, ["create", "edit"])), { unset: "Unset", increase: "Increase", decrease: "Decrease", createToken: "Create token", revokeToken: "Revoke token", addNewMedia: "Add new media", useCustomScreen: "Use custom screen", showRoomDelete: "Showroom delete", saveMedia: "Save Media" }),
    _a[TrackingActionCategory.ANALYTICS] = __assign(__assign(__assign({}, defaultUIOptions), (0, lodash_pick_1.default)(defaultUIOptions, ["filter", "export", "changeTheme"])), { zoomIn: "Zoom in", zoomOut: "Zoom out", viewChange: "View change", dateRangeChange: "Date range change", passageSettingsChange: "Passage settings change" }),
    _a[TrackingActionCategory.ACTIVITY] = __assign(__assign({}, (0, lodash_pick_1.default)(defaultUIOptions, ["refresh"])), { loadMore: "Load more" }),
    _a[TrackingActionCategory.SERVER] = {
        apiCredit: "Api credit",
        clearDemoData: "Clear demo data",
        clearFirebaseCount: "Clear firebase count",
        countAssign: "Count Assign",
        pubSub: "Pubsub",
        kpiScheduler: "Kpi scheduler",
        kpiAssign: "Kpi assign",
        kpiWorke: "Kpi assign",
        clearDeviceTimeout: "Clear device timeout",
        jobReminder: "Job reminder",
    },
    _a[TrackingActionCategory.RETAIL] = __assign(__assign({}, defaultOptions), defaultUIOptions),
    _a);
var TrackingSocketEvents;
(function (TrackingSocketEvents) {
    TrackingSocketEvents["LOG_ERROR"] = "logError";
    TrackingSocketEvents["LOG_ACTION"] = "logAction";
    TrackingSocketEvents["LOG_VIEW_ACTIVITY"] = "logViewActivity";
    TrackingSocketEvents["SET_USER"] = "setUser";
    TrackingSocketEvents["SET_LANGUAGE"] = "setLanguage";
    TrackingSocketEvents["CONNECT"] = "createConnection";
    TrackingSocketEvents["END_CONNECTION"] = "endConnection";
})(TrackingSocketEvents = exports.TrackingSocketEvents || (exports.TrackingSocketEvents = {}));
